
(() => {
  const finitions = {Frost: "#D6D8DA", Basalt: "#2B2C2F"};
  const nomFinition = v => v.split(" (")[0];
  const sections = () => (document.querySelector("cart-drawer") ? ["cart-drawer", "cart-icon-bubble"] : []);

  async function ajouter(items, direct) {
    const corps = {items};
    if (!direct && sections().length) { corps.sections = sections(); corps.sections_url = window.location.pathname; }
    const r = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + "cart/add.js" : "/cart/add.js",
      {method: "POST", headers: {"Content-Type": "application/json", Accept: "application/json"}, body: JSON.stringify(corps)});
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || "Could not add to cart");
    if (direct) { window.location.href = "/checkout"; return; }
    const tiroir = document.querySelector("cart-drawer");
    if (tiroir && j.sections) { tiroir.classList.remove("is-empty"); tiroir.renderContents(j); }
    else window.location.href = "/cart";
  }

  // Page produit : gamme → taille → teinte.
  document.querySelectorAll("[data-rundet-achat]").forEach(z => {
    const variantes = JSON.parse(z.querySelector("[data-variantes]").textContent);
    const v0 = variantes.find(v => v.option1 === "MacBook Pro" && v.option2 === "16-inch" && v.option3.startsWith("Basalt")) || variantes[0];
    const st = {o1: v0.option1, o2: v0.option2, o3: v0.option3, qte: 1};
    const uniq = a => [...new Set(a)];
    const $ = s => z.querySelector(s);
    const courante = () => variantes.find(v => v.option1 === st.o1 && v.option2 === st.o2 && v.option3 === st.o3);
    function rendu() {
      const g = uniq(variantes.map(v => v.option1));
      const t = uniq(variantes.filter(v => v.option1 === st.o1).map(v => v.option2));
      if (!t.includes(st.o2)) st.o2 = t[t.length - 1];
      const f = uniq(variantes.filter(v => v.option1 === st.o1 && v.option2 === st.o2).map(v => v.option3));
      if (!f.includes(st.o3)) st.o3 = f[0];
      $("[data-gammes]").innerHTML = g.map(x => `<button type="button" class="pill${x === st.o1 ? " actif" : ""}" data-o1="${x}">${x}</button>`).join("");
      $("[data-tailles]").innerHTML = t.map(x => `<button type="button" class="pill${x === st.o2 ? " actif" : ""}" data-o2="${x}">${x}</button>`).join("");
      $("[data-teintes]").innerHTML = f.map(x => `<button type="button" class="swatch${x === st.o3 ? " actif" : ""}" title="${x}" data-o3="${x}"><span style="background:${finitions[nomFinition(x)] || "#ccc"}"></span></button>`).join("");
      const sombre = nomFinition(st.o3) === "Basalt";
      $("[data-teinte-nom]").innerHTML = `<b>${nomFinition(st.o3)}</b> ${st.o3.slice(nomFinition(st.o3).length)} · for ${sombre ? "dark" : "light"} Macs`;
      $("[data-pour]").textContent = `For ${st.o1} ${st.o2}`;
      $("[data-qte]").textContent = st.qte;
    }
    z.addEventListener("click", async e => {
      const b = e.target.closest("button");
      if (!b) return;
      if (b.dataset.o1) st.o1 = b.dataset.o1;
      else if (b.dataset.o2) st.o2 = b.dataset.o2;
      else if (b.dataset.o3) st.o3 = b.dataset.o3;
      else if (b.dataset.q === "-") st.qte = Math.max(1, st.qte - 1);
      else if (b.dataset.q === "+") st.qte = Math.min(10, st.qte + 1);
      else if (b.dataset.ajout !== undefined) {
        const v = courante(); if (!v) return;
        b.disabled = true; $("[data-erreur]").textContent = "";
        try { await ajouter([{id: v.id, quantity: st.qte}], b.dataset.ajout === "direct"); st.qte = 1; }
        catch (err) { $("[data-erreur]").textContent = err.message; }
        b.disabled = false;
      }
      rendu();
    });
    document.querySelectorAll("[data-rundet-collant]").forEach(c => c.addEventListener("click", () => z.querySelector('[data-ajout="panier"]').click()));
    rendu();
  });

  // Encart du tiroir : second Rundet à -50 %.
  document.addEventListener("change", e => {
    const o = e.target.closest(".rundet-offre");
    if (!o || !e.target.matches("select")) return;
    const variantes = JSON.parse(o.querySelector("[data-variantes]").textContent);
    const [s1, s2, s3] = o.querySelectorAll("select");
    if (e.target === s1) {
      const t = [...new Set(variantes.filter(v => v.option1 === s1.value).map(v => v.option2))];
      const garde = t.includes(s2.value) ? s2.value : t[t.length - 1];
      s2.innerHTML = t.map(x => `<option${x === garde ? " selected" : ""}>${x}</option>`).join("");
    }
  });
  // Carrousel des teintes : une image par teinte dans le dessin, montrées tour à tour.
  document.querySelectorAll("[data-carrousel]").forEach(c => {
    const imgs = [...c.querySelectorAll("image[data-teinte]")];
    const noms = imgs.map(i => i.dataset.teinte);
    let k = 0, auto = null, x0 = null;
    const montrer = i => {
      k = (i + noms.length) % noms.length;
      imgs.forEach((im, j) => { im.style.opacity = j === k ? 1 : 0; });
      c.querySelectorAll("[data-car-teinte]").forEach(b => b.classList.toggle("actif", b.dataset.carTeinte === noms[k]));
    };
    const arret = () => { clearInterval(auto); auto = null; };
    c.addEventListener("click", e => {
      const b = e.target.closest("button[data-car-teinte]");
      if (!b) return;
      arret();
      montrer(noms.indexOf(b.dataset.carTeinte));
    });
    // Balayage : événements « pointer » (doigt, stylet, souris tirée), et défilement horizontal du
    // pavé tactile ou de la souris (molette inclinée). Un balayage n'ouvre pas le zoom.
    let glisse = false;
    c.addEventListener("pointerdown", e => { if (!e.target.closest("button")) { x0 = e.clientX; glisse = false; } });
    c.addEventListener("pointerup", e => {
      if (x0 === null) return;
      const dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { glisse = true; arret(); montrer(k + (dx < 0 ? 1 : -1)); }
    });
    c.addEventListener("pointercancel", () => { x0 = null; });
    c.addEventListener("click", e => { if (glisse) { e.stopPropagation(); e.preventDefault(); glisse = false; } }, true);
    // Un geste du pavé tactile = une teinte : verrou jusqu'à 250 ms sans défilement.
    let cumul = 0, verrou = false, repos = null;
    c.addEventListener("wheel", e => {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      clearTimeout(repos);
      repos = setTimeout(() => { verrou = false; cumul = 0; }, 250);
      if (verrou) return;
      cumul += e.deltaX;
      if (Math.abs(cumul) > 30) { verrou = true; arret(); montrer(k + (cumul > 0 ? 1 : -1)); }
    }, {passive: false});
    montrer(0);
    auto = setInterval(() => montrer(k + 1), 4000);
  });

  // Zoom plein écran sur les dessins et les photos.
  document.addEventListener("click", e => {
    const el = e.target.closest(".rundet svg.croquis, .rundet .photos img, .rundet .emballage img");
    if (!el) return;
    const z = document.createElement("div");
    z.className = "rundet-zoom";
    z.setAttribute("role", "dialog");
    z.setAttribute("aria-modal", "true");
    let c;
    if (el.tagName === "IMG") { c = new Image(); c.src = el.dataset.zoom || el.currentSrc || el.src; c.alt = el.alt; }
    else { c = el.cloneNode(true); c.removeAttribute("class"); c.setAttribute("preserveAspectRatio", "xMidYMid meet"); }
    z.append(c);
    const x = document.createElement("button");
    x.type = "button"; x.setAttribute("aria-label", "Close"); x.textContent = "×";
    z.append(x);
    const fermer = () => { z.remove(); document.removeEventListener("keydown", touche); document.documentElement.style.overflow = ""; };
    const touche = k => { if (k.key === "Escape") fermer(); };
    z.addEventListener("click", fermer);
    document.addEventListener("keydown", touche);
    document.documentElement.style.overflow = "hidden";
    document.body.append(z);
    x.focus();
  });

  document.addEventListener("click", async e => {
    const b = e.target.closest("[data-rundet-offre]");
    if (!b) return;
    e.preventDefault();
    const o = b.closest(".rundet-offre");
    const variantes = JSON.parse(o.querySelector("[data-variantes]").textContent);
    const [s1, s2, s3] = [...o.querySelectorAll("select")].map(s => s.value);
    const v = variantes.find(x => x.option1 === s1 && x.option2 === s2 && x.option3 === s3);
    if (!v) return;
    b.disabled = true;
    try { await ajouter([{id: v.id, quantity: 1}], false); } catch (err) { b.disabled = false; alert(err.message); }
  });
})();
